<template>
  <div class="uk-grid-small uk-child-width-1-2 uk-child-width-1-2@s uk-text-center mb-4 user-statistics" uk-grid>
    <div>
      <div class="course-card uk-card-hover profile">
        <div class="course-card-body stat-card">
          <h4>{{ userItem.assignments_count }}</h4>
          <p> {{ $t('home.education_assigned') }} </p>
        </div>
      </div>
    </div>
    <div>
      <div class="course-card uk-card-hover profile">
        <div class="course-card-body stat-card">
          <h4>{{ userItem.completed_assignments_count }}</h4>
          <p> {{ $t('general.completed_education') }}</p>
        </div>
      </div>
    </div>
    <div>
      <div class="course-card uk-card-hover profile">
        <div class="course-card-body stat-card">
          <h4>{{ giftsCount }}</h4>
          <p>{{ $t('general.won_a_gift') }} </p>
        </div>
      </div>
    </div>
    <div>
      <div class="course-card uk-card-hover profile">
        <div class="course-card-body stat-card">
          <h4>{{ userPoint }} / {{ userCoin }}</h4>
          <p> {{ $t('home.point_coin') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserStatistics',
  props: {
    userItem: {
      type: Object,
      default: () => ({})
    },
    giftsCount: {
      type: Number,
      default: 0
    },
    userPoint: {
      type: Number,
      default: 0
    },
    userCoin: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.stat-card {
  padding: 18px 12px !important;
  min-height: 40px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.stat-card h4 {
  font-size: 24px !important;
  font-weight: 700 !important;
  min-height: 40px !important;
  margin-bottom: 0 !important;
  color: #2c3e50;
  line-height: 1.2;
}

.stat-card p {
  font-size: 13px !important;
  margin: 0 !important;
  color: #7f8c8d;
  font-weight: 500;
  line-height: 1.4;
}
</style>
